import React, { Fragment, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import Avatar from "../images/avatar.png"
import { allUsersAction, clearErrors, loadUserAction } from '../../redux/actions/userActions'
import SingleUserComponent from './SingleUser'
import { toast } from 'react-toastify'
import UpdateAvatar from "./UpdateAvatar"
import Loader from '../loader/loader'
import { UPDATE_AVATAR_RESET } from '../../redux/constants/userConstants'
import useNavHighlight from '../../hooks/useNavHighlight'
import usePageMeta from '../../hooks/usePageMeta'


const Profile = () => {





    const dispatch = useDispatch()

    const { user } = useSelector((state) => state.verifyEmailStore);
    const { users } = useSelector((state) => state.allUsers)
    const { error, message } = useSelector((state) => state.updateRole)

    const { loading, error: avatarError, message: avatarMessage } = useSelector((state) => state.updateAvatar)

    const [showSection, setShowSection] = useState(false)




    useNavHighlight("profile");
    usePageMeta("profile");



    useEffect(() => {

        if (user?.role === "Admin") {
            dispatch(allUsersAction())
        }

    }, [user, dispatch])




    useEffect(() => {


        if (message) {
            toast.success(message)
            dispatch(clearErrors())
            dispatch(allUsersAction())

        }

        if (error) {
            toast.error(error)
            dispatch(clearErrors())
        }



    }, [dispatch, message, error])


    const hideSection = useCallback(() => {
        setShowSection(false)
    }, [])




    useEffect(() => {

        if (avatarMessage) {
            toast.success(avatarMessage)
            dispatch({ type: UPDATE_AVATAR_RESET })   // clear first to prevent running twice
            dispatch(loadUserAction())
            hideSection()
        }

        if (avatarError) {
            toast.error(avatarError)
            dispatch(clearErrors())
        }

    }, [dispatch, avatarMessage, avatarError, hideSection])



    return (
        <Fragment>
            {loading && <Loader />}

            <section className='pl-[1.5vmax] pr-[1.5vmax] lg:pr-[2.5vmax]' >
                <div className="flex justify-between items-center bg-white p-[1.2vmax] rounded-[1vmax] px-[2vmax]">
                    <h2 className='text-[1.3vmax] font-bold' >Profile</h2>
                    <div className="flex-center gap-[0.8vmax] text-[1vmax]">
                        <Link to={'/'} >
                            Dashboard
                        </Link>
                        <div className='w-[0.3vmax] h-[0.3vmax] rounded-[50%] bg-black' >
                        </div>
                        <span className='text-slate-400 text-extralight' >
                            Profile
                        </span>
                    </div>
                </div>
            </section>
            <section className='pl-[1.5vmax] pr-[1.5vmax] lg:pr-[2.5vmax]' >
                <div className="mt-[2vmax] profile-bg p-[3vmax] rounded-[1vmax]">
                    <div className="flex bg-white shadow-1 p-[2vmax] rounded-[1vmax] gap-[2vmax]">
                        <div className="w-[6vmax]">
                            <img src={user?.avatar_url || Avatar} alt="" className='w-[6vmax] h-[6vmax] rounded-[50%]' />
                        </div>
                        <div className="w-[70%]">
                            <h3 className='text-[1.5vmax] capitalize font-3 font-bold flex items-center' >
                                <span  >{user?.name}</span>
                                <span className={`text-[0.9vmax] font-[600] ml-[1vmax]  px-[0.5vmax] rounded-[1vmax] border-[0.14vmax] 
                            ${user?.role === 'Admin' ?
                                        'border-green-500  text-green-500 bg-green-100'
                                        :

                                        user?.role === 'Unauthorized' ?
                                            'border-red-500  text-red-500 bg-red-100'
                                            :
                                            'border-[var(--color-2)]  text-[var(--color-2)] bg-[var(--color-2-light)]'

                                    }
                            `} >{user?.role}</span> </h3>
                            <button className='mt-[0.5vmax] text-[1vmax] text-gray-600' onClick={() => setShowSection(true)} >
                                <i className="fa-solid fa-pen-to-square pr-[0.5vmax]"></i>
                                {user?.avatar_url ? 'Change Avatar' : 'Upload Avatar'}
                            </button>
                            <div className='flex items-center pt-[0.4vmax]' >
                                <span className='w-[0.4vmax] h-[0.4vmax] bg-green-500 rounded-[50%]' ></span>
                                <span className='text-[0.9vmax] pl-[0.3vmax]' >Active</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='pl-[1.5vmax] pr-[1.5vmax] lg:pr-[2.5vmax]' >
                {user?.role === 'Admin' &&
                    <h3 className='my-[1vmax] text-center text-[1.5vmax] font-2 font-bold text-gray-600' > <i className="fa-solid fa-people-group"></i> Teams</h3>
                }
                {user?.role === 'Admin' &&
                    <div className="flex justify-between flex-wrap gap-y-[2vmax]">
                        {users?.length > 0 &&
                            users.map((SingleUser) =>
                                user?.email !== SingleUser.email && (
                                    <SingleUserComponent key={SingleUser._id} user={SingleUser} />
                                )
                            )
                        }

                    </div>
                }

            </section>
            {
                showSection &&
                <UpdateAvatar hideSection={hideSection} avatar_url={user?.avatar_url} />

            }

            <br />
            <br />
            <br />
            <br />
        </Fragment>
    )
}

export default Profile